import React from 'react';

import { useGetEvent } from '@vlabs/api/artemy/client';
import type { EventId } from '@vlabs/api/artemy/model/EventId';

import {
  EventFaceDetectionSamplePoint3,
  EventBodyDetectionSamplePoint3,
  AdditionalPropertiesBySampleId,
} from '@vlabs/monokit/entities/event-details';

import st from './EventDetectionProperties.module.sass';
import { useEventDetectionTranslation } from '../i18n';

interface EventDetectionPropertiesPoint3Props {
  eventId: EventId;
}
function EventDetectionPropertiesPoint3({
  eventId,
}: EventDetectionPropertiesPoint3Props): React.JSX.Element {
  const { t } = useEventDetectionTranslation();

  const { data: event } = useGetEvent(eventId, { target: ['face_detections', 'body_detections'] });
  const faceSampleId = event?.face_detections?.[0]?.sample_id;
  const bodySampleId = event?.body_detections?.[0]?.sample_id;

  return (
    <div className={st.Root}>
      <div className={st.Samples}>
        <EventFaceDetectionSamplePoint3
          className={st.Sample}
          sampleId={faceSampleId ?? ''}
        />
        {!!event?.body_detections?.length && (
          <EventBodyDetectionSamplePoint3
            className={st.Sample}
            sampleId={bodySampleId ?? ''}
          />
        )}
      </div>
      <div className={st.Properties}>
        {!!faceSampleId && <AdditionalPropertiesBySampleId sampleId={faceSampleId} />}
        {!faceSampleId && <span className={st.NoData}>{t('no_data')}</span>}
      </div>
    </div>
  );
}

export { EventDetectionPropertiesPoint3 };
